import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'access-agent-builder',
  name: 'Agent Builder',
  category: 'ai',
  description:
    'Chat with AI agents from the Access Agent Builder platform (no credentials required - uses Access Identity)',
  icon: 'Bot',
  iconType: 'lucide',
  color: 'violet',
  version: '1.0.0',

  defaults: {
    name: 'Agent Builder',
    color: '#8b5cf6', // Violet color
  },

  comingSoon: false,
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  tags: ['access', 'agent', 'builder', 'ai', 'chat', 'mcp'],

  // Tool-capable configuration for AI Agent
  toolCapable: {
    enabled: true,
    name: 'access_agent_builder',
    description:
      'Chat with AI agents from the Access Agent Builder platform. Supports agent chat, listing available agents, and getting agent details.',
    allowManualDescription: false,
    parameters: {
      operation: {
        toolParamName: 'operation',
        description:
          'The operation to perform: chatWithAgent, listAgents, or getAgent',
        required: true,
        type: 'string',
      },
      agentId: {
        toolParamName: 'agentId',
        description:
          'The ID of the agent to interact with (required for chatWithAgent and getAgent)',
        required: false,
        type: 'string',
      },
      message: {
        toolParamName: 'message',
        description:
          'The message/prompt to send to the agent (required for chatWithAgent)',
        required: false,
        type: 'string',
      },
      conversationId: {
        toolParamName: 'conversationId',
        description:
          'Optional conversation ID for maintaining context across invocations',
        required: false,
        type: 'string',
      },
    },
    outputMapping: {
      success: 'Whether the operation succeeded',
      operation: 'The operation that was performed',
      agentId: 'The agent ID (for chat and get operations)',
      data: 'The response data from the API',
      conversationId: 'The conversation ID for follow-up messages',
    },
  },
};

export default definition;
